import styled from "styled-components";

export const Sessao = styled.div`
  width: 100%;
  margin: 50px 0 20px;
  padding: 0 30px;
  @media screen and (max-width: 768px) {
    margin-top: 40px;
  }
  @media screen and (max-width: 414px) {
    padding: 0 24px;
  }
`;
export const Container = styled.div`
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  overflow-wrap: break-word;

  img {
    width: 100%;
    max-height: 300px;
    transform: scale(100%);
    object-fit: cover;
  }
`;

export const Header = styled.div`
  display: flex;

  width: 100%;

  p {
    font-size: 13px;
    align-self: flex-start;
    margin-bottom: 30px;
    color: #071242;
  }

  a {
    font-size: 13px;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-right: 7px;
    color: #071242;
    font-weight: bold;

    &:hover {
      color: #df8c07;
      transition: color 0.3s;
    }
  }
`;
